// extracted by mini-css-extract-plugin
export default {"exit":"Exit_exit__uIuCE","appear":"Exit_appear__1h7a6"};